/* Jonelia Health 2026 – robuste, intent-basierte Gesundheitssuche */
(function () {
  'use strict';

  /* Spezifische Sortimentsbereiche zuerst, danach Gesundheitswelten. */
  var topics = [
    { terms: ['haarshampoo','shampoo','haarpflege','haarmaske','conditioner'], label: 'Haarpflege', url: '/collections/kat-haarpflege' },
    { terms: ['sonnenschutz','sonnencreme','after sun','lsf','spf'], label: 'Sonnenschutz & After Sun', url: '/collections/kat-sonnenschutz' },
    { terms: ['baby','mama','schwangerschaft','stillzeit'], label: 'Baby & Mama', url: '/collections/kat-baby-mama' },
    { terms: ['intimpflege','intimwasch','gleitgel'], label: 'Intimpflege', url: '/collections/kat-intimpflege-libido' },
    { terms: ['bienengift','bienenprodukt','propolis','honig'], label: 'Bienenprodukte', url: '/collections/bienenprodukte' },
    { terms: ['homoeopathie','homöopathie','bachblueten','bachblüten','schuessler','schüssler'], label: 'Homöopathie, Bachblüten & Schüßler', url: '/collections/kat-homoeopathie-bachblueten' },
    { terms: ['tee','kraeutertee','kräutertee','getraenk','getränk','lebensmittel'], label: 'Lebensmittel & Tee', url: '/collections/lebensmittel-tee' },
    { terms: ['tiergesundheit','haustier','hund','katze'], label: 'Tiergesundheit', url: '/collections/nahrungserganzung-tiere' },
    { terms: ['beauty','kosmetik','gesichtspflege','koerperpflege','körperpflege','pflegeprodukt'], label: 'Beauty & Pflege', url: '/collections/beauty-pflege' },
    { terms: ['nahrungsergaenzung','nahrungsergänzung','vitamin','mineralstoff','magnesium','zink','kapsel','tablette'], label: 'Nahrungsergänzung', url: '/collections/nahrungsergaenzung' },

    /* Bereiche, die beim Ausbau des Sortiments schon jetzt sinnvoll suchbar sind. */
    { terms: ['selbsttest','schnelltest','antigentest','covid test','influenzatest','grippetest'], label: 'Selbsttests & Diagnostik', search: 'selbsttest' },
    { terms: ['medizinprodukt','fieberthermometer','thermometer','blutdruck','blutdruckmessgeraet','blutdruckmessgerät','inhalator'], label: 'Medizinprodukte & Geräte', search: 'medizinprodukt' },
    { terms: ['desinfektion','desinfektionsmittel','hygiene'], label: 'Hygiene & Desinfektion', search: 'hygiene' },
    { terms: ['erste hilfe','wundversorgung','wunde','verband','wundpflaster'], label: 'Erste Hilfe & Wundversorgung', search: 'erste hilfe' },
    { terms: ['mundpflege','zahnpflege','zahnbuerste','zahnbürste','zahncreme','mundspuelung','mundspülung'], label: 'Mund- & Zahnpflege', search: 'zahnpflege' },

    /* Gesundheitswelten */
    { terms: ['haar','haare','haut','nagel','naegel','nägel','biotin','kollagen'], label: 'Haut, Haare & Nägel', url: '/collections/welt-haut-haare-naegel' },
    { terms: ['schlaf','einschlafen','entspannung','melatonin'], label: 'Schlaf & Entspannung', url: '/collections/welt-schlaf-entspannung' },
    { terms: ['stress','balance','ashwagandha','ruhe'], label: 'Stress & Balance', url: '/collections/welt-stress-balance' },
    { terms: ['darm','verdauung','probiotika','magen'], label: 'Darm & Verdauung', url: '/collections/welt-darm-verdauung' },
    { terms: ['energie','muedigkeit','müdigkeit','erschoepfung','erschöpfung','b12'], label: 'Energie & Vitalität', url: '/collections/welt-energie' },
    { terms: ['immunsystem','immun','abwehr'], label: 'Immunsystem', url: '/collections/welt-immunsystem' },
    { terms: ['herz','kreislauf','omega 3','omega-3'], label: 'Herz & Kreislauf', url: '/collections/welt-herz-kreislauf' },
    { terms: ['gelenk','gelenke','knochen','msm','glucosamin'], label: 'Knochen & Gelenke', url: '/collections/welt-knochen-gelenke' },
    { terms: ['konzentration','gedaechtnis','gedächtnis','gehirn','fokus'], label: 'Konzentration & Gedächtnis', url: '/collections/welt-konzentration-gedaechtnis' },
    { terms: ['gewicht','stoffwechsel','berberin'], label: 'Gewicht & Stoffwechsel', url: '/collections/welt-gewicht-stoffwechsel' },
    { terms: ['detox','leber','mariendistel','artischocke'], label: 'Detox & Leber', url: '/collections/welt-detox-leber' },
    { terms: ['frau','frauen','women'], label: 'Für Frauen', url: '/collections/welt-frauen' },
    { terms: ['mann','maenner','männer','men','instant strong','erefit'], label: 'Für Männer', url: '/collections/welt-maenner' },
    { terms: ['kind','kinder','kids','gummies'], label: 'Kinder & Familie', url: '/collections/kinder-familie' },
    { terms: ['auge','augen','seh'], label: 'Augen', url: '/collections/welt-augen' },
    { terms: ['aging','healthy aging','q10','nad'], label: 'Healthy Aging', url: '/collections/welt-healthy-aging' },
    { terms: ['sport','regeneration','kreatin','protein','performance'], label: 'Sport & Regeneration', url: '/collections/welt-sport-regeneration' },
    { terms: ['libido','sexualitaet','sexualität'], label: 'Intimität & Libido', url: '/collections/welt-intimitaet-libido' }
  ];

  var activeInput = null;
  var activeForm = null;
  var panel = null;
  var timer = null;
  var controller = null;
  var requestId = 0;

  function normalise(value) {
    var text = (value || '').toLowerCase();
    if (text.normalize) text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return text.trim();
  }

  function topicFor(query) {
    var q = normalise(query);
    if (!q) return null;
    for (var i = 0; i < topics.length; i++) {
      for (var j = 0; j < topics[i].terms.length; j++) {
        var term = normalise(topics[i].terms[j]);
        if (q.indexOf(term) !== -1 || (q.length >= 3 && term.indexOf(q) === 0)) return topics[i];
      }
    }
    return null;
  }

  function make(tag, className, textValue) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (typeof textValue === 'string') el.textContent = textValue;
    return el;
  }

  function link(href, className) {
    var a = make('a', className);
    a.href = href;
    return a;
  }

  function getRoot() {
    var root = '/';
    if (window.Shopify && Shopify.routes && Shopify.routes.root) root = Shopify.routes.root;
    return root.replace(/\/$/, '');
  }

  function searchUrl(query) {
    var base = '/search';
    if (activeForm && activeForm.action) {
      try {
        var u = new URL(activeForm.action, window.location.origin);
        base = u.pathname;
      } catch (e) {}
    }
    return base + '?type=product&q=' + encodeURIComponent(query);
  }

  function topicUrl(topic, query) {
    if (!topic) return searchUrl(query);
    if (topic.url) return topic.url;
    return searchUrl(topic.search || query);
  }

  function money(value) {
    if (value === null || typeof value === 'undefined' || value === '') return '';
    var n = parseFloat(value);
    if (isNaN(n)) return String(value);
    var currency = 'EUR';
    if (window.Shopify && Shopify.currency && Shopify.currency.active) currency = Shopify.currency.active;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-AT', { style: 'currency', currency: currency }).format(n);
    } catch (e) {
      return n.toFixed(2).replace('.', ',') + ' €';
    }
  }

  function imageUrl(product) {
    var image = product && product.featured_image;
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.url || image.src || '';
  }

  function ensureStyles() {
    if (document.getElementById('jon-search-fixed-styles')) return;
    var style = document.createElement('style');
    style.id = 'jon-search-fixed-styles';
    style.textContent =
      '.jon-search-panel.jon-search-panel--fixed{position:fixed!important;left:auto;right:auto;top:auto;z-index:2147483000!important;width:auto;max-width:none!important;box-sizing:border-box;padding:12px;border-radius:20px;background:#fff;border:1px solid rgba(31,77,58,.13);box-shadow:0 24px 70px rgba(16,42,32,.24);overflow:auto;overscroll-behavior:contain;}' +
      '.jon-search-panel--fixed .jon-search__header{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:4px 5px 10px;}' +
      '.jon-search-panel--fixed .jon-search__header strong{font-size:13px;color:#1b2622;}' +
      '.jon-search-panel--fixed .jon-search__close{border:0;background:#f2f5f3;width:32px;height:32px;border-radius:50%;font-size:20px;line-height:1;color:#1f4d3a;cursor:pointer;}' +
      '.jon-search-panel--fixed .jon-search__topic{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:13px 14px;border-radius:14px;background:linear-gradient(135deg,#edf5ef,#faf7ef);border:1px solid rgba(31,77,58,.09);color:#1b2622;text-decoration:none;}' +
      '.jon-search-panel--fixed .jon-search__topic>span{display:grid;gap:2px;}.jon-search-panel--fixed .jon-search__topic small,.jon-search-panel--fixed .jon-search__label{font-size:10px;text-transform:uppercase;letter-spacing:.11em;font-weight:800;color:#6b776f;}' +
      '.jon-search-panel--fixed .jon-search__topic strong{font-size:15px;color:#1f4d3a;}' +
      '.jon-search-panel--fixed .jon-search__label{margin:14px 5px 7px;}' +
      '.jon-search-panel--fixed .jon-search__products{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:7px;}' +
      '.jon-search-panel--fixed .jon-search__product{display:grid;grid-template-columns:58px minmax(0,1fr);gap:10px;align-items:center;padding:8px;border-radius:13px;border:1px solid transparent;color:#1b2622;text-decoration:none;}' +
      '.jon-search-panel--fixed .jon-search__product:hover{background:#f5f8f6;border-color:rgba(31,77,58,.08);}' +
      '.jon-search-panel--fixed .jon-search__product img,.jon-search-panel--fixed .jon-search__product-placeholder{width:58px;height:58px;border-radius:10px;object-fit:contain;background:#f8f8f6;}' +
      '.jon-search-panel--fixed .jon-search__product-placeholder{display:grid;place-items:center;color:#759084;font:700 23px Georgia,serif;}' +
      '.jon-search-panel--fixed .jon-search__product-copy{display:grid;gap:4px;min-width:0;}.jon-search-panel--fixed .jon-search__product-copy strong{font-size:12.5px;line-height:1.3;color:#1b2622;}.jon-search-panel--fixed .jon-search__product-copy small{font-size:12px;color:#53645b;}' +
      '.jon-search-panel--fixed .jon-search__links{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:6px;}.jon-search-panel--fixed .jon-search__link{display:flex;justify-content:space-between;gap:10px;padding:10px 11px;border-radius:12px;background:#fafbf9;color:#1b2622;text-decoration:none;font-size:12px;font-weight:700;}' +
      '.jon-search-panel--fixed .jon-search__all{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-top:10px;padding:12px 13px;border-radius:14px;background:#1f4d3a;color:#fff!important;text-decoration:none;font-size:12.5px;font-weight:800;}' +
      '.jon-search-panel--fixed .jon-search__empty,.jon-search-panel--fixed .jon-search__loading{margin:12px 6px 3px;color:#657168;font-size:12px;line-height:1.45;}' +
      '.search-bar.jon-search-active .search-bar__results,.search-bar.jon-search-active .search-bar__inner~*{visibility:hidden!important;}' +
      '@media(max-width:700px){.jon-search-panel.jon-search-panel--fixed{left:10px!important;right:10px!important;width:auto!important;max-height:calc(100vh - 90px)!important;border-radius:17px;}.jon-search-panel--fixed .jon-search__products,.jon-search-panel--fixed .jon-search__links{grid-template-columns:1fr;}}';
    document.head.appendChild(style);
  }

  function ensurePanel() {
    ensureStyles();
    if (panel && document.body.contains(panel)) return panel;
    panel = make('div', 'jon-search-panel jon-search-panel--fixed');
    panel.id = 'jonelia-search-suggestions';
    panel.hidden = true;
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-label', 'Suchvorschläge');
    document.body.appendChild(panel);
    panel.addEventListener('click', function (event) {
      if (event.target.closest('.jon-search__close')) close();
    });
    return panel;
  }

  function positionPanel() {
    if (!panel || panel.hidden || !activeInput) return;
    var rect = activeInput.getBoundingClientRect();
    if (window.innerWidth <= 700) {
      panel.style.top = Math.max(10, rect.bottom + 8) + 'px';
      panel.style.left = '10px';
      panel.style.right = '10px';
      panel.style.width = 'auto';
      panel.style.maxHeight = Math.max(220, window.innerHeight - rect.bottom - 22) + 'px';
      return;
    }
    var width = Math.min(Math.max(rect.width, 520), 920);
    var left = rect.left;
    if (left + width > window.innerWidth - 14) left = window.innerWidth - width - 14;
    if (left < 14) left = 14;
    panel.style.left = Math.round(left) + 'px';
    panel.style.right = 'auto';
    panel.style.top = Math.round(rect.bottom + 8) + 'px';
    panel.style.width = Math.round(width) + 'px';
    panel.style.maxHeight = Math.max(240, Math.min(620, window.innerHeight - rect.bottom - 24)) + 'px';
  }

  function open() {
    ensurePanel();
    panel.hidden = false;
    if (activeForm) activeForm.classList.add('jon-search-active');
    if (activeInput) {
      activeInput.setAttribute('aria-controls', panel.id);
      activeInput.setAttribute('aria-expanded', 'true');
    }
    positionPanel();
  }

  function close() {
    if (panel) {
      panel.hidden = true;
      panel.replaceChildren();
    }
    if (activeForm) activeForm.classList.remove('jon-search-active');
    if (activeInput) activeInput.setAttribute('aria-expanded', 'false');
  }

  function addHeader(query) {
    var head = make('div', 'jon-search__header');
    head.appendChild(make('strong', '', 'Treffer für „' + query + '“'));
    var btn = make('button', 'jon-search__close', '×');
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Suchvorschläge schließen');
    head.appendChild(btn);
    panel.appendChild(head);
  }

  function addTopic(query) {
    var topic = topicFor(query);
    if (!topic) return false;
    var a = link(topicUrl(topic, query), 'jon-search__topic');
    var copy = make('span');
    copy.appendChild(make('small', '', 'Passender Bereich'));
    copy.appendChild(make('strong', '', topic.label));
    a.appendChild(copy);
    a.appendChild(make('b', '', '→'));
    panel.appendChild(a);
    return true;
  }

  function productCard(product) {
    var a = link(product.url || '#', 'jon-search__product');
    var src = imageUrl(product);
    if (src) {
      var img = document.createElement('img');
      img.src = src;
      img.alt = (product.featured_image && product.featured_image.alt) || product.title || '';
      img.loading = 'lazy';
      a.appendChild(img);
    } else {
      a.appendChild(make('span', 'jon-search__product-placeholder', 'J'));
    }
    var copy = make('span', 'jon-search__product-copy');
    copy.appendChild(make('strong', '', product.title || 'Produkt'));
    var formatted = money(product.price_min || product.price);
    if (formatted) copy.appendChild(make('small', '', formatted));
    a.appendChild(copy);
    return a;
  }

  function renderBase(query, loading) {
    ensurePanel();
    panel.replaceChildren();
    addHeader(query);
    addTopic(query);
    if (loading) panel.appendChild(make('p', 'jon-search__loading', 'Passende Produkte und Bereiche werden geladen …'));
    var all = link(searchUrl(query), 'jon-search__all');
    all.appendChild(make('span', '', 'Alle Ergebnisse anzeigen'));
    all.appendChild(make('b', '', '→'));
    panel.appendChild(all);
    open();
  }

  function renderResults(query, data) {
    ensurePanel();
    panel.replaceChildren();
    addHeader(query);
    var hasTopic = addTopic(query);
    var resources = data && data.resources && data.resources.results ? data.resources.results : {};
    var products = resources.products || [];
    var collections = resources.collections || [];
    var pages = resources.pages || [];
    var articles = resources.articles || [];

    if (products.length) {
      panel.appendChild(make('p', 'jon-search__label', 'Produkte'));
      var productGrid = make('div', 'jon-search__products');
      products.slice(0, 6).forEach(function (product) { productGrid.appendChild(productCard(product)); });
      panel.appendChild(productGrid);
    }

    var other = collections.concat(pages, articles).slice(0, 4);
    if (other.length) {
      panel.appendChild(make('p', 'jon-search__label', 'Weitere Treffer'));
      var links = make('div', 'jon-search__links');
      other.forEach(function (item) {
        var a = link(item.url || '#', 'jon-search__link');
        a.appendChild(make('span', '', item.title || 'Mehr entdecken'));
        a.appendChild(make('b', '', '→'));
        links.appendChild(a);
      });
      panel.appendChild(links);
    }

    if (!hasTopic && !products.length && !other.length) {
      panel.appendChild(make('p', 'jon-search__empty', 'Keine direkten Vorschläge gefunden. Über die vollständige Suche können Sie trotzdem das gesamte Jonelia-Sortiment durchsuchen.'));
    }

    var all = link(searchUrl(query), 'jon-search__all');
    all.appendChild(make('span', '', 'Alle Ergebnisse für „' + query + '“'));
    all.appendChild(make('b', '', '→'));
    panel.appendChild(all);
    open();
  }

  function fetchResults(query) {
    var current = ++requestId;
    if (controller) controller.abort();
    controller = window.AbortController ? new AbortController() : null;
    var url = getRoot() + '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product,collection,page,article&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last';
    fetch(url, controller ? { signal: controller.signal, headers: { Accept: 'application/json' } } : { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Predictive search failed');
        return response.json();
      })
      .then(function (json) {
        if (current !== requestId || !activeInput || activeInput.value.trim() !== query) return;
        renderResults(query, json);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        if (current !== requestId) return;
        renderResults(query, null);
      });
  }

  function activate(input) {
    if (!input) return;
    if (activeForm && activeForm !== input.closest('form')) activeForm.classList.remove('jon-search-active');
    activeInput = input;
    activeForm = input.closest('form.search-bar') || input.closest('form');
  }

  document.addEventListener('input', function (event) {
    var input = event.target.closest && event.target.closest('.search-bar__input');
    if (!input) return;
    activate(input);
    var query = input.value.trim();
    window.clearTimeout(timer);
    if (query.length < 2) {
      close();
      return;
    }
    renderBase(query, true);
    timer = window.setTimeout(function () { fetchResults(query); }, 140);
  }, true);

  document.addEventListener('focusin', function (event) {
    var input = event.target.closest && event.target.closest('.search-bar__input');
    if (!input) return;
    activate(input);
    var query = input.value.trim();
    if (query.length >= 2) {
      renderBase(query, true);
      window.clearTimeout(timer);
      timer = window.setTimeout(function () { fetchResults(query); }, 80);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
  });

  document.addEventListener('click', function (event) {
    if (!panel || panel.hidden) return;
    if (panel.contains(event.target)) return;
    if (activeForm && activeForm.contains(event.target)) return;
    close();
  });

  window.addEventListener('resize', positionPanel, { passive: true });
  window.addEventListener('scroll', positionPanel, { passive: true });
})();